import { Tabs } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export const DTabs = withStyles({
    root: {
      borderBottom: '0px',      
    },
    indicator: {
      backgroundColor: 'transparent',
    },
})(Tabs);